import React, { memo, useContext } from 'react';
import CookiePolicySettingsLink from "../cookie-policy-settings-link";
import FooterContext from "../../footer-context";
import { useMainContext } from "../../../main-context";
import LanguageSwitcher from "../../footer-language-switcher";
import MapMarker from "./map-marker";
import { Container, Copyright, Location, LanguageSwitcherContainer, CookiePolicySettingsContainer } from "./styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CompanyInfoSection = function CompanyInfoSection() {
  var _useContext = useContext(FooterContext),
    isCompact = _useContext.isCompact,
    palette = _useContext.palette;
  var _useMainContext = useMainContext(),
    t = _useMainContext.t,
    locale = _useMainContext.locale;
  return /*#__PURE__*/_jsxs(Container, {
    "data-locale": locale,
    isCompact: isCompact,
    palette: palette,
    children: [/*#__PURE__*/_jsxs(Location, {
      children: [/*#__PURE__*/_jsx(MapMarker, {}), t('public-footer.location')]
    }), /*#__PURE__*/_jsx(LanguageSwitcherContainer, {
      children: /*#__PURE__*/_jsx(LanguageSwitcher, {})
    }), /*#__PURE__*/_jsx(CookiePolicySettingsContainer, {
      children: /*#__PURE__*/_jsx(CookiePolicySettingsLink, {})
    }), /*#__PURE__*/_jsx(Copyright, {
      children: "\xA9 Typeform"
    })]
  });
};
export default /*#__PURE__*/memo(CompanyInfoSection);